import http from "../../http";

const userlogout = {
    removeBatchCustomer(param){
        return http.confirm.tip.post("/gateway/api/lfuser/userRemove/removeBatchCustomer", param);
    },
}
export default userlogout